import React from 'react';

const TransactionAdd = () => {
  return (
    <div>
      <h1>Add Notarial Book</h1>
      {/* Add form and logic here */}
    </div>
  );
};

export default TransactionAdd;